import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/soonoGetStarted.css';
import SignUpWrapper from 'containers/SignUpWrapper';
import { TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import { checkValidity, handleFormValidate } from 'utils/formvalidate';
import UsersApi from 'apis/Users';
import {
  setContactDetails,
  getContactDetails,
} from 'constants/localStorageManager';
import InputField from './InputField';
import Toaster from '../Toaster';

const assignFormValuetoKeys = formValues => {
  const formKeys = Object.keys(formValues);
  const formData = {};

  formKeys.forEach(key => {
    formData[key] = formValues[key].value;
  });

  return formData;
};

class TrialContactDetails extends Component {
  constructor() {
    super();
    this.state = {
      formValues: {
        email: {},
        password: {},
        firstName: {},
        lastName: {},
        phone: {},
      },
      isPasswordVisible: false,
    };
  }

  componentDidMount() {
    const contactDetails = getContactDetails();
    const { location } = this.props;
    if (contactDetails) this.changeStep(location.pathname);
  }

  handleSubmit = e => {
    e.preventDefault();
    const form = this.refs.signupForm;
    const { hasErrors, formValues } = handleFormValidate(form);
    this.setState({ hasErrors, formValues });
    if (!hasErrors) this.updateContactDetails();
  };

  updateContactDetails = () => {
    const { location } = this.props;
    const { formValues } = this.state;
    const contactDetails = assignFormValuetoKeys(formValues);
    const {
      email,
      password,
      firstName: first_name,
      lastName: last_name,
      phone: phone_number,
    } = contactDetails;

    UsersApi.addNewUser({
      first_name,
      last_name,
      phone_number,
      email,
      password,
      password_confirmation: password,
    })
      .then(({ data }) => {
        setContactDetails({ ...data, password });
        this.changeStep(location.pathname);
      })
      .catch(({ response }) => {
        const { data } = response || {};
        const { email: emailError } = data || {};
        const errorText = emailError
          ? `Email '${email}' is already taken`
          : 'Something went wrong. Please try again later';
        Toaster.getErrorToaster('exclamation-triangle', errorText);
      });
  };

  changeStep = currentPathName => {
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    this.props.history.push(nextStep.path);
  };

  handleChange = e => {
    const { name, value, required, type } = e.target;
    const _state = { ...this.state };
    const hasError = checkValidity({ name, value, type, required });
    _state.formValues[name] = {
      value,
      hasError,
    };

    this.setState({ ..._state });
  };

  togglePassword = () => {
    this.setState(({ isPasswordVisible }) => ({
      isPasswordVisible: !isPasswordVisible,
    }));
  };

  render() {
    const { location } = this.props;
    const { formValues, isPasswordVisible } = this.state;
    const passwordType = isPasswordVisible ? 'text' : 'password';

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS}
        currentStep={location.pathname}
      >
        <div className="col-md-6 offset-md-3">
          <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
            Your free 7 day Trial Starts Now!
          </h3>
          <p className="text-dark">No Credit Card Required.</p>
          <form
            ref="signupForm"
            className="form mt-4 mb-5 text-left text-dark soono-transaction-form"
          >
            <div className="form-group mb-3">
              <InputField
                formValues={formValues}
                name="email"
                label="Email"
                type="email"
                handleChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label for="password">Password</label>
              <InputGroup>
                <InputField
                  formValues={formValues}
                  name="password"
                  type={passwordType}
                  handleChange={this.handleChange}
                  noError
                  required
                />
                <InputGroupAddon
                  className="ml-1"
                  addonType="append"
                  onClick={this.togglePassword}
                >
                  <InputGroupText
                    className={`text-center ${
                      isPasswordVisible ? 'password-toggle' : ''
                    }`}
                  >
                    <FontAwesomeIcon className="text-center" icon="eye" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
              {formValues.password.hasError && (
                <div className="row error">Password is required</div>
              )}
            </div>
            <hr className="mb-3"></hr>
            <div className="row">
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="First Name"
                  placeholder=""
                  name="firstName"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div class="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="Last Name"
                  placeholder=""
                  name="lastName"
                  handleChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-group mb-4">
              <InputField
                formValues={formValues}
                type="tel"
                label="Phone Number"
                placeholder=""
                name="phone"
                handleChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group">
              <button
                className=" btn-warning btn-lg col-md-12 py-3 pl-5 pr-5 text-white text-bold border-0 cursor-pointer"
                type="button"
                onClick={this.handleSubmit}
              >
                Get Started
              </button>
            </div>
            <p className="text-center">
              By Signing up I agree to the{' '}
              <Link className="text-underline" to="/terms-of-use">
                Terms
              </Link>{' '}
              and{' '}
              <Link className="text-underline" to="/privacy-policy">
                Privacy Policy
              </Link>
            </p>
          </form>
        </div>
      </SignUpWrapper>
    );
  }
}

export default TrialContactDetails;



// WEBPACK FOOTER //
// ./src/components/transactions/TrialContactDetails.js